import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  UpdatecarAction,
  createCarAction,
  getAllCarAction,
  getAllCategoryAction,
} from "../../../redux/actions/CarAction";
import {
  Autocomplete,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import { Button, Col, Modal, Row, Spinner } from "react-bootstrap";
import Addcategory from "./addcategory";
import notify from "../../../Notifcation";
import MultiImageInput from "react-multiple-image-input";
const Addcar = ({
  setcategoryname,
  categoryname,
  setyear,
  year,
  setchassenumber,
  chassenumber,
  setcartype,
  cartype,
  model,
  setmodel,
  loading,
  setLoading,
  setIsEdit,
  IsEdit,
  carid,
  setcarid,
  key,
  setKey,
  setdescrip,
  descrip,
  setprice,
  price,
  setImages,
  images,
  setisPress,
  isPress,
  setCarImageId,
  CarImageId,
  setVideoy,
  Videoy,
  Motor,
  setMotor,
  setcolor,
  color,
  setCarNumber,
  CarNumber,
}) => {
  const [showPop, setshowPop] = useState(false);
  const handleCloseMain = () => setshowPop(false);
  const handleShowMain = () => setshowPop(true);
  const dispatch = useDispatch();
  const crop = {
    unit: "%",
    aspect: 4 / 3,
    width: "1000",
  };
  useEffect(() => {
    dispatch(getAllCategoryAction());
  }, [showPop]);
  const AllCat = useSelector((state) => state.CarReduser.GetAllCategory);
  //to convert base 64 to file
  function dataURLtoFile(dataurl, filename) {
    var arr = dataurl.split(","),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type: mime });
  }

  const handlesubmit = async (e) => {
    e.preventDefault();
    if (
      year === "" ||
      model === "" ||
      chassenumber === "" ||
      cartype === "" ||
      categoryname === "" ||
      price === "" ||
      descrip === "" ||
      images.length <= 0 ||
      Motor === "" ||
      color === "" ||
      CarNumber === ""
    ) {
      notify("من فضلك اكمل البيانات المطلوبة", "error");
      return;
    }
    const imgCover = dataURLtoFile(images[0], Math.random() + ".png");
    //convert array of base 64 image to file
    const itemImages = Array.from(Array(Object.keys(images).length).keys()).map(
      (item, index) => {
        return dataURLtoFile(images[index], Math.random() + ".png");
      }
    );
    const formData = new FormData();
    formData.append("model", model);
    formData.append("year_car", year);
    formData.append("car_type", cartype);
    formData.append("category_name", categoryname.id);
    formData.append("chassis_number", chassenumber);
    formData.append("car_image", imgCover);
    formData.append("video ", Videoy);
    formData.append("car_number ", CarNumber);

    formData.append("color ", color);
    formData.append("motor_number", Motor);
    // formData.append("car_images", itemImages);
    itemImages.map((item) => {
      return formData.append("car_images", item);
    });
    formData.append("price", price);
    formData.append("description", descrip);
    setisPress(true);
    await dispatch(createCarAction(formData));
    setcartype("");
    setmodel("");
    setchassenumber("");
    setisPress(false);
    setcategoryname("");
    setCarNumber("");
    setcolor("");
    setyear("");
    setMotor("");
    setVideoy("");
    setcarid("");
    setImages([]);
    setprice("");
    setLoading(false);
    setdescrip("");
  };
  const handlesubmitUpdate = async (e) => {
    e.preventDefault();
    if (
      year === "" ||
      model === "" ||
      chassenumber === "" ||
      cartype === "" ||
      categoryname === "" ||
      price === "" ||
      descrip === "" ||
      Motor === "" ||
      color === "" ||
      CarNumber === ""
    ) {
      notify("من فضلك اكمل البيانات المطلوبة", "error");
      return;
    }

    const imgCover = dataURLtoFile(images[0], Math.random() + ".png");
    //convert array of base 64 image to file
    const itemImages = Array.from(Array(Object.keys(images).length).keys()).map(
      (item, index) => {
        return dataURLtoFile(images[index], Math.random() + ".png");
      }
    );

    const formData = new FormData();
    formData.append("car_id", carid);
    formData.append("model", model);
    formData.append("year_car", year);
    formData.append("car_type", cartype);
    formData.append("category_name", categoryname.id);
    formData.append("car_number ", CarNumber);
    formData.append("chassis_number", chassenumber);
    formData.append("car_image", imgCover);
    formData.append("color ", color);
    formData.append("video ", Videoy);
    formData.append("motor_number", Motor);
    formData.append("car_images_ids", CarImageId.join(","));
    itemImages.map((item) => {
      return formData.append("car_images", item);
    });

    formData.append("price", price);
    formData.append("description", descrip);
    setisPress(true);
    await dispatch(UpdatecarAction(formData));
    setLoading(false);
    setIsEdit(false);
    setCarNumber("");
    setisPress(false);
    setcartype("");
    setcolor("");
    setmodel("");
    setchassenumber("");
    setcategoryname("");
    setyear("");
    setcarid("");
    setImages([]);
    setMotor("");
    setVideoy("");
    setprice("");
    setdescrip("");
  };

  const res = useSelector((state) => state.CarReduser.createCar);
  const Update = useSelector((state) => state.CarReduser.UpdateCar);
  useEffect(() => {
    if (loading === false) {
      setTimeout(() => setLoading(true), 1500);
      if (res) {
        if (res.status === 201 || res.status === 200) {
          if (res.data) {
            notify(res.data.message, "success");
            dispatch(getAllCarAction());
            dispatch(getAllCategoryAction());
          }
        } else if (res.status !== 200 || res.status !== 201) {
          if (res.data && res.data.message) {
            notify(res.data.message, "error");
            dispatch(getAllCarAction());
            dispatch(getAllCategoryAction());
          } else {
            notify("هناك مشكلة حاول مرة اخرى", "error");
            dispatch(getAllCarAction());
            dispatch(getAllCategoryAction());
          }
        }
      }
      if (Update) {
        if (Update.status === 200 || Update.status === 201) {
          if (Update.data) {
            notify(Update.data.message, "success");
            dispatch(getAllCategoryAction());
            dispatch(getAllCarAction());
            setTimeout(() => setKey("display"), 2000);
          }
        } else if (Update.status !== 200 || Update.status !== 201) {
          if (Update.data) {
            notify(Update.data.message, "error");
            dispatch(getAllCategoryAction());
            dispatch(getAllCarAction());
          }
          notify("هناك مشكلة حاول مرة اخرى", "error");
          dispatch(getAllCategoryAction());
          dispatch(getAllCarAction());
        } else {
          notify("هناك مشكلة حاول مرة اخرى", "error");
          // dispatch(getAllCategoryAction());
          // dispatch(getAllCarAction());
        }
      }
    }
  }, [loading]);
  return (
    <div>
      {" "}
      <Row>
        <Col md="12">
          <h5>صور السيارة</h5>
          <MultiImageInput
            images={images}
            cropConfig={{ crop, ruleOfThirds: true }}
            setImages={setImages}
            theme={"light"}
            allowCrop={false}
            max={8}
          />
        </Col>
      </Row>
      <div className="inputs-container">
        <div className="inp-container ">
          <Autocomplete
            disablePortal
            id="combo-box-demo"
            value={categoryname}
            options={AllCat && AllCat.length >= 0 ? AllCat : []}
            sx={{ width: 300 }}
            onChange={(e, v) => setcategoryname(v)}
            getOptionLabel={(option) => {
              // Value selected with enter, right from the input
              if (typeof option === "string") {
                return option;
              }
              // Add "xxx" option created dynamically
              if (option.inputValue) {
                return option.inputValue;
              }
              // Regular option
              return option.name;
            }}
            // renderOption={(props, option) => (
            //   <li {...props} key={option.id}>
            //     {option.name}
            //   </li>
            // )}
            renderInput={(params) => (
              <TextField
                {...params}
                label={
                  <Typography>
                    نوع السيارة
                    <span style={{ color: "red", fontSize: "21px" }}>*</span>
                  </Typography>
                }
              />
            )}
          />
          <i
            onClick={handleShowMain}
            className="ty fa-solid fa-circle-plus"
          ></i>
        </div>
        <div className="inp-container ">
          <TextField
            label={
              <Typography>
                الموديل
                <span style={{ color: "red", fontSize: "21px" }}>*</span>
              </Typography>
            }
            type="text"
            value={model}
            onChange={(e) => {
              setmodel(e.target.value);
            }}
            variant="outlined"
          />
        </div>
        <div className="inp-container ">
          <TextField
            label={
              <Typography>
                سنة الصنع
                <span style={{ color: "red", fontSize: "21px" }}>*</span>
              </Typography>
            }
            type="number"
            value={year}
            onChange={(e) => setyear(e.target.value)}
            variant="outlined"
          />
        </div>
        <div className="inp-container ">
          <TextField
            label={
              <Typography
              >
             اللون
                <span style={{ color: "red", fontSize: "21px" }}>
                  *
                </span>
              </Typography>
            }
            type="text"
            value={color}
            onChange={(e) => setcolor(e.target.value)}
            variant="outlined"
          />
        </div>
        <div className="inp-container ">
          <TextField
            label={
              <Typography
              >
             رقم الشاسية
                <span style={{ color: "red", fontSize: "21px" }}>
                  *
                </span>
              </Typography>
            }
            type="number"
            value={chassenumber}
            onChange={(e) => setchassenumber(e.target.value)}
            variant="outlined"
          />
        </div>
        <div className="inp-container ">
          <TextField
            label={
              <Typography
              >
             قدرة الموتور
                <span style={{ color: "red", fontSize: "21px" }}>
                  *
                </span>
              </Typography>
            }
            type="number"
            value={Motor}
            onChange={(e) => setMotor(e.target.value)}
            variant="outlined"
          />
        </div>
        <div className="inp-container ">
          <TextField
            label={
              <Typography
              >
             رقم السيارة
                <span style={{ color: "red", fontSize: "21px" }}>
                  *
                </span>
              </Typography>
            }
            type="number"
            value={CarNumber}
            onChange={(e) => setCarNumber(e.target.value)}
            variant="outlined"
          />
        </div>
        <div className="inp-container ">
          <TextField
            label="رابط اليوتيوب"
            type="text"
            value={Videoy}
            onChange={(e) => setVideoy(e.target.value)}
            variant="outlined"
          />
        </div>
        <div className="inp-container">
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">
              <Typography
              >
             نوع الملكية
                <span style={{ color: "red", fontSize: "21px" }}>
                  *
                </span>
              </Typography>
            </InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              label={
                <Typography
                >
               نوع الملكية
                  <span style={{ color: "red", fontSize: "21px" }}>
                    *
                  </span>
                </Typography>
              }
              value={cartype}
              onChange={(e) => setcartype(e.target.value)}
            >
              <MenuItem value={"F"}>أول مالك</MenuItem>
              <MenuItem value={"D"}>معاقين</MenuItem>
              <MenuItem value={"Z"}>الزيرو</MenuItem>
            </Select>
          </FormControl>
        </div>
        <div className="inp-container">
          {" "}
          <TextField
            value={price}
            onChange={(e) => setprice(e.target.value)}
            label={
              <Typography
              >
             السعر
                <span style={{ color: "red", fontSize: "21px" }}>
                  *
                </span>
              </Typography>
            }
            type="number"
            variant="outlined"
          />
        </div>
        <div className="inp-container">
          {" "}
          <TextField
            value={descrip}
            onChange={(e) => setdescrip(e.target.value)}
            label={
              <Typography
              >
             الوصف
                <span style={{ color: "red", fontSize: "21px" }}>
                  *
                </span>
              </Typography>
            }
            type="text"
            multiline
            variant="outlined"
          />
        </div>

        <div className="inp-container "></div>

        <div className="inp-container "></div>
      </div>
      {loading && isPress ? (
        <button className="buttonadd">
          <Spinner />
        </button>
      ) : IsEdit ? (
        <button className="buttonadd" onClick={handlesubmitUpdate}>
          تعديل
        </button>
      ) : (
        <button className="buttonadd" onClick={handlesubmit}>
          إضافة
        </button>
      )}
      <Modal
        show={showPop}
        onHide={handleCloseMain}
        backdrop="static"
        centered
        keyboard={false}
        contentClassName="cont"
        style={{ width: "100%", margin: "0px auto", textAlign: "center" }}
      >
        <Modal.Header closeButton>
          <Modal.Title>إضافة الفئات</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {" "}
          <Addcategory />{" "}
        </Modal.Body>

        <Modal.Footer>
          <Button
            variant="secondary"
            className="close"
            onClick={handleCloseMain}
          >
            إغلاق
          </Button>
        </Modal.Footer>
      </Modal>
      {/* <ToastContainer /> */}
    </div>
  );
};

export default Addcar;
